import { productLineToSkuCategoryName } from '../v2/constants';
import { useHasProductLevelOrHigherInProductInventory } from '../v2/hooks/inventory/useHighestProductLevel';
import { isValidApiName } from '../v2/utils/typeguards';
import { useLegacyAllCommonTermsForProducts } from './useBulkPurchaseOptions';

/**
 * @deprecated Temporary workaround for PPUIv1 - DO NOT USE OR COPY THIS IN PPUI V2
 * @description This hook is used to determine if the term toggle can be shown on a product merch card.
 *
 * @example
 * const shouldShowTermToggle = useShouldShowTermToggleForMerchCard(product);
 *
 * @returns A boolean indicating if the term toggle should be shown for the merch card.
 */
export const useShouldShowTermToggleForMerchCard = product => {
  const {
    commonTerms
  } = useLegacyAllCommonTermsForProducts({
    apiNames: isValidApiName(product === null || product === void 0 ? void 0 : product.apiName) ? [product.apiName] : undefined
  });
  const hasTwoTerms = commonTerms.length > 1;
  const skuCategoryName = product !== null && product !== void 0 && product.productLine ? productLineToSkuCategoryName[product.productLine] : undefined;
  const {
    hasProductLevelOrHigher: ownsProductOrHigher
  } = useHasProductLevelOrHigherInProductInventory({
    productLevel: product === null || product === void 0 ? void 0 : product.productLevel,
    skuCategoryName
  });
  return hasTwoTerms && !ownsProductOrHigher;
};